import styled from "styled-components";
import { IconButton, IconButtonButton, MultiSelectContainer } from "@evergis/ui";

export const StyledIconButton = styled(IconButton)`
  width: 0.75rem;
  height: 0.75rem;

  span[kind] {
    height: 0.75rem;

    :after {
      font-size: 0.75rem;
    }
  }
`;

export const TextFilterContainer = styled.div`
  width: 15.85rem;

  ${MultiSelectContainer} {
    color: ${({ theme: { palette } }) => palette.textPrimary};

    ${IconButtonButton} {
      span[kind]:after {
        color: ${({ theme: { palette } }) => palette.textPrimary};
      }
    }
  }
`;
